import styled, { css } from "styled-components";
import Typography from "@pagepro-monorepo/ui/lib/components/styles/Typography";
import media from "@pagepro-monorepo/ui/lib/theme/config/media";

import { StyledNumberProps } from "./types";

export const Number = styled(Typography).attrs({
  variant: "heading2",
  forwardedAs: "p"
})<StyledNumberProps>`
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `};
`;

export const Title = styled.div`
  @media ${media.tablet} {
    max-width: 34rem;
  }
`;

export const Description = styled.div`
  @media ${media.tablet} {
    max-width: 25.75rem;
  }
`;
